import { Component, attr } from "../Component";
import {element} from "../CustomElement";
import { Page } from "../flipp-page/Page";
import BreadcrumbsService from "../../services/BreadcrumbsService";
import renderBreadcrumbs from "../renderBreadcrumbs";
import {inject} from "../../services/di";
import { SeoService } from "../../services/SeoService";

interface ICategoriesBrowser {
	categories: string;
}

@element("flipp-categories-browser")
export class CategoriesBrowser extends Component<ICategoriesBrowser, {}> {
	@attr categories: string;
	@inject breadcrumbsService: BreadcrumbsService;
	@inject seoService: SeoService;

	renderTree(categories: any): HTMLElement {
		return (
			<ol>
				{categories.map((c: any) => (
					<div>
						<li><a href={c.url}>{c.category}</a></li>
						{c.subCategories ? this.renderTree(c.subCategories) : null}
					</div>
				))}
			</ol>
		);
	}

	render() {
		const categories = JSON.parse(this.props.categories);
		const breadcrumbs = this.breadcrumbsService.getBrowserBreadcrumbs();
		const currentLocation = this.breadcrumbsService.getCurrentLocation();

		this.seoService.insertLoadingMarker(70);
		return (
			<Page show="flyers">
				{renderBreadcrumbs(breadcrumbs, currentLocation)}
				{this.renderTree(categories)}
			</Page>
		);
	}
}
